import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RaffleService } from '../../services/raffle.service';
import { Raffle } from '../../../influencer/models/raffle.model';
import { ApiResponse } from '../../../../shared/models/api-response.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { getApiErrorMessage } from '../../../../shared/utils/error-utils';
import {
  catchError,
  finalize,
  forkJoin,
  map,
  of,
  Subject,
  takeUntil,
} from 'rxjs';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Paths } from '../../../../core/constants/path.constants';
import { RaffleStatus } from '../../models/raffle.model';
import { InfluencerService } from '../../../influencer/services/influencer.service';
import { Profile } from '../../../profile/model/profile.model';
import { AppStateService } from '../../../../core/services/app-state.service';

@Component({
  selector: 'vota-raffles',
  templateUrl: './raffles.component.html',
  styleUrls: ['./raffles.component.scss'],
})
export class RafflesComponent implements OnInit, OnDestroy {
  @Input() username: string | null = null;
  isLoading = false;
  raffles$: Observable<Raffle[]> = of([]);
  RaffleStatus = RaffleStatus;
  trendingProfile: Profile | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    private raffleService: RaffleService,
    private influencerService: InfluencerService,
    private toastr: ToastrService,
    private appStateService: AppStateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.username
      ? this.getRafflesByInfluencer(this.username)
      : this.getAllRaffles();
    this.appStateService.setTitle('Vota')
  }

  getAllRaffles(): void {
    this.isLoading = true;
    forkJoin({
      raffles: this.raffleService.getAllRaffles().pipe(
        map((res) => res?.data ?? []),
        catchError((error) => {
          this.toastr.error(getApiErrorMessage(error));
          return of([]);
        })
      ),
      trendingProfile: this.influencerService.getTrendingInfluencer().pipe(
        map((res) => res?.data ?? null),
        catchError((error) => {
          this.toastr.error(getApiErrorMessage(error));
          return of(null);
        })
      ),
    })
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: ({ raffles, trendingProfile }) => {
          this.raffles$ = of(raffles);
          this.trendingProfile = trendingProfile;
        },
      });
  }

  getRafflesByInfluencer(username: string): void {
    this.isLoading = true;
    this.raffles$ = this.raffleService.getRafflesByInfluencer(username).pipe(
      map((res: ApiResponse<Raffle[] | null>) => res?.data ?? []),
      catchError((error: HttpErrorResponse) => {
        this.toastr.error(getApiErrorMessage(error));
        return of([]);
      }),
      finalize(() => (this.isLoading = false))
    );
  }

  onRaffleClick(raffle: Raffle): void {
    this.router.navigate([Paths.EVENT, raffle.slug]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
